{
  "gcrm": {
    "topbar.home.title": "Home",
    "topbar.partners.title": "Partners",
    "topbar.br.replacement": "Prospecting BR",
    "topbar.businessRelations.title": "Business relationships",
    "topbar.distributionCenter.title": "Distribution center",
    "topbar.versioning.error": "Error fetching versions.",
    "topbar.documentCenter.title": "Document center",
    "topbar.versioning.active": "Viewing",
    "topbar.versioning.draft": "Editing (Draft)",
    "topbar.versioning.lockedDraft": "Locked (Draft)",
    "topbar.versioning.draftInReview": "Draft in review",
    "topbar.versioning.inEditing": "In editing",
    "drawer.support.snow": "Snow Request",
    "drawer.title": "Support",
    "drawer.section.contactNoteUpload.title": "Contact note upload",
    "drawer.section.contactNoteUpload.fileLimitExceed": "File size exceeds the maximum limit of 12MB",
    "drawer.section.bugInformationOverlay.title": "Bug information overlay",
    "drawer.section.bugInformationOverlay.text": "Enable or disable show information on existing bugs within CLM.",
    "drawer.section.bugInformationOverlay.gravity": "“Gravity” bug overlay",
    "drawer.section.support.title": "Support",
    "drawer.section.support.text": "Business support",
    "drawer.section.support.tel": "**1166 (Please use Option #1 for AOS)",
    "drawer.section.support.bugReporting": "Bug reporting",
    "drawer.section.support.bugReporting.text": "Please use the link below to report a bug.",
    "drawer.section.feedback.title": "Feedback",
    "drawer.section.feedback.text": "Please use the link below to submit feedback.",
    "drawer.section.feedback.button": "Send feedback",
    "drawer.section.additionalResources.title": "Additional resources",
    "drawer.section.additionalResources.clmUserGuide": "CLM User Guide",
    "drawer.section.additionalResources.clmUserGuide.link": " CLM User Guide (juliusbaer.com)",
    "tabs.menu.closed": "(Closed)",
    "tabs.menu.categories.profile": "Profile",
    "tabs.menu.categories.general": "General",
    "tabs.menu.categories.products-and-services": "Products & services",
    "tabs.menu.categories.relationships": "Relationships",
    "tabs.menu.categories.interactions": "Client contacts",
    "tabs.menu.categories.documents": "Documents",
    "partnerTabs.menu.coreData": "Core data",
    "partnerTabs.menu.partnerProfile": "Partner profile",
    "partnerTabs.menu.wealthProfile": "Wealth profile",
    "partnerTabs.menu.riskConsiderations": "Risk considerations",
    "partnerTabs.menu.investmentProfile": "Investment profile",
    "partnerTabs.menu.p2br": "Business relations",
    "partnerTabs.menu.p2p": "Partner relations",
    "partnerTabs.menu.contactNotes": "Contact notes",
    "partnerTabs.menu.activityTimeline": "Activity timeline",
    "partnerTabs.menu.distributionCenter": "Distribution center",
    "partnerTabs.menu.distribution": "Distribution",
    "partnerTabs.menu.documentOverview": "Document overview",
    "partnerTabs.menu.docCollection": "Doc collection",
    "accounts.tabs.coreData.title": "Core data",
    "accounts.tabs.readiness.buttonText": "Client setup readiness",
    "accounts.tabs.readiness.modalTitle": "Attestation",
    "accounts.tabs.more.title": "More",
    "accounts.tabs.more.reject": "Reject (Bank PoV)",
    "accounts.tabs.more.withdraw": "Withdraw (Partner PoV)",
    "accounts.tabs.more.withdraw.modal.title": "Alert",
    "accounts.tabs.more.withdraw.modal.comment": "Comment",
    "accounts.tabs.more.withdraw.modal.title.confirmText": "Are you sure you want to {{purpose}} this business relation? You can't undo this step.",
    "accounts.tabs.more.deactivate": "Deactivate BR",
    "accounts.tabs.more.deactivate.modal.title": "BR deactivation confirmation",
    "accounts.tabs.more.deactivate.modal.confirmText": "Hereby I confirm:",
    "accounts.tabs.more.deactivate.modal.confirmTextAlertAttention": "Attention",
    "accounts.tabs.more.deactivate.modal.confirmTextAlert": "After confirmation and deactivation of the BR, it cannot be reactivated.",
    "accounts.tabs.more.deactivate.modal.confirmTextItem1": "I have followed the Regular Termination guidance in <0>EAM/EFA Business Process Tool</0>",
    "accounts.tabs.more.deactivate.modal.confirmTextItem2": "I have closed all Products & Services related with this BR",
    "accounts.tabs.more.deactivate.modal.confirmTextItem3": "I have followed all instructed actions prior of closing the BR in CLM",
    "accounts.tabs.more.deactivate.modal.confirmTextItem4": "All pending compliance tasks (e.g. name screening, transaction monitoring) concerning the BR and respective partners have been resolved and are documented appropriately",
    "accounts.tabs.more.deactivate.modal.confirmStatusTextItems": [
      "All BR relations roles (e.g., Account Holder; Authorized Signatories) will be expired. The partner(s) will not be set to Inactive only the relation to this BR",
      "The BR will be set to read only (except of Doc Collection and Contact notes)",
      "The final remaining segmentation codes will be automatically deleted by the system upon deactivation of this BR"
    ],
    "accounts.tabs.more.deactivate.openTasks.modal.tasksOpenError": "In order to deactivate the BR, kindly close all open tasks related to this BR or its related partner.",
    "accounts.tabs.more.deactivate.openTasks.modal.title": "BR deactivation - additional action required",
    "accounts.tabs.brRelations.title": "BR-partner relations",
    "accounts.tabs.investmentProfile.title": "Investment profile",
    "accounts.tabs.brServicing.title": "Servicing users",
    "accounts.tabs.brDeliveryInstructions.title": "Delivery instructions",
    "accounts.tabs.blockingInstructions.title": "Blocking Instructions & Restrictions",
    "accounts.tabs.blockingInstructions.blocked.label": "(BLOCKED)",
    "accounts.tabs.blockingInstructions.blocked.secretLabel": "(BLOCKED secret)",
    "accounts.tabs.blockingInstructions.blocked.secretTooltip": "BR is blocked from business activity. The client may not be informed of the background details. Please find the details in the blocking instruction section.",
    "accounts.tabs.blockingInstructions.blocked.knownTooltip": "BR is blocked from business activity. The client may be informed about the background details. Please find the details in the blocking instruction section.",
    "accounts.tabs.blockingInstructions.error.details": "Error fetching blocking instructions from br-mgmt",
    "accounts.tabs.blockingInstructions.error.title": "Error fetching blocking instructions",
    "accounts.tabs.blockingInstructions.error.userMessage": "An error occurred when fetching blocking instructions data",
    "accounts.tabs.brPurpose.title": "BR profile",
    "accounts.tabs.contactNotes.title": "Contact notes",
    "accounts.tabs.productServices.title": "Products & services",
    "accounts.tabs.reporting.title": "Reporting",
    "accounts.tabs.profile.title": "Profile",
    "accounts.tabs.relations.title": "Relations",
    "accounts.tabs.documents.title": "Documents",
    "accounts.tabs.documentOverview.title": "Document overview",
    "accounts.tabs.distribution.title": "Distribution",
    "accounts.tabs.distributionCenter.title": "Distribution center",
    "accounts.tabs.doccollection.title": "Doc collection",
    "accounts.tabs.financials.title": "Financials",
    "accounts.dlm.lock.title": "This profile is partially and temporarily locked due to an ongoing onboarding workflow",
    "accounts.tabs.riskConsiderations.title": "Risk considerations",
    "accounts.tabs.clientReview.title": "Client reviews",
    "partner.tabs.financials.title": "Financials",
    "partner.tabs.contactnote.importedWarning": "This partner is directly linked to an intermediary BR, please capture your intermediary related contact note directly on the intermediary BR.",
    "partnerDetails.summary.top.title": "Partner summary",
    "partnerDetails.summary.editHistory": "Edit history",
    "partnerDetails.summary.lastEdit": "Last edit",
    "partnerDetails.summary.editedBy": "Edited by",
    "partnerDetails.summary.created": "Created",
    "partnerDetails.summary.createdBy": "Created by",
    "partnerDetails.summary.partnerInformation": "Partner information",
    "partnerDetails.summary.partnerId": "Partner ID",
    "partnerDetails.summary.lifecycle": "Lifecycle",
    "partnerDetails.summary.preferredEmail": "Preferred e-mail",
    "partnerDetails.summary.preferredEmailComment": "Preferred e-mail comment",
    "partnerDetails.summary.preferredPhone": "Preferred phone",
    "partnerDetails.summary.preferredPhoneComment": "Preferred phone comment",
    "partnerDetails.summary.mainDomicile": "Main domicile",
    "partnerDetails.summary.contactNotes": "Contact notes",
    "partnerDetails.summary.newContactNote": "New contact note",
    "partnerDetails.summary.remarks": "Remarks",
    "partnerDetails.lifecyclePriority.top.title": "Lifecycle & priority",
    "partnerDetails.lifecyclePriority.lifecycle": "Lifecycle",
    "partnerDetails.lifecyclePriority.brStatus": "Status",
    "partnerDetails.lifecyclePriority.priority": "Priority",
    "partnerDetails.coreData.top.title": "Core Data",
    "partnerDetails.coreData.gender": "Gender",
    "partnerDetails.coreData.salutation": "Salutation",
    "partnerDetails.coreData.title": "Title",
    "partnerDetails.coreData.firstName": "First name",
    "partnerDetails.coreData.lastName": "Last name",
    "partnerDetails.coreData.middleName": "Middle name",
    "partnerDetails.coreData.maidenName": "Maiden name",
    "partnerDetails.coreData.nationality": "Nationality",
    "partnerDetails.coreData.language": "Language",
    "partnerDetails.coreData.dateOfBirth": "Date of birth",
    "partnerDetails.coreData.dateOfDeath": "Date of death",
    "partnerDetails.coreData.maritalStatus": "Marital status",
    "partnerDetails.coreData.countryOfBirth": "Country of birth",
    "partnerDetails.coreData.cityOfBirth": "City of birth",
    "partnerDetails.coreData.introductionChannel": "introduction channel",
    "partnerDetails.coreData.bjbEmployeeType": "BJB employee",
    "partnerDetails.coreData.dateOfLeaving": "Date of leaving",
    "partnerDetails.contactFatca.top.title": "Tax details",
    "partnerDetails.contactFatca.fatcaUsQi": "FATCA/US QI",
    "partnerDetails.contactFatca.profileFatcaRelevant": "This profile is FATCA relevant.",
    "partnerDetails.contactFatca.profileNotFatcaRelevant": "This profile is not FATCA relevant.",
    "partnerDetails.contactFatca.isUSCitizen": "Is the person a U.S. citizen?",
    "partnerDetails.contactFatca.isUSBorn": "Was the person born in the U.S. or a U.S. territory?",
    "partnerDetails.contactFatca.renouncedUsCitizenship": "Did the person renounce the US citizenship (valid certificate of loss of nationality)?",
    "partnerDetails.contactFatca.usGreenCardPossessed": "Is the person in possession of a \"green card\" (irrespective of its expiry date)?",
    "partnerDetails.contactFatca.isUSResidentAlien": "Is the person a U.S. resident (i.e do they meet the substantial presence test)?",
    "partnerDetails.contactFatca.isUSTaxLiable": "Is the person considered to be unlimitedly liable for taxation in the U.S. for any other reason?",
    "partnerEdit.lifecyclePriority.top.title": "Lifecycle & priority",
    "partnerEdit.lifecyclePriority.lifecycle": "Lifecycle",
    "partnerEdit.lifecyclePriority.brStatus": "Status",
    "partnerEdit.lifecyclePriority.priority": "Priority",
    "partnerEdit.b2bToggle.b2bPartner": "B2B partner",
    "partnerEdit.b2bToggle.b2bType": "B2B type",
    "partnerEdit.b2bToggle.intermediary": "Intermediary",
    "partnerEdit.b2bToggle.insurance": "Insurance",
    "partnerEdit.b2bToggle.finder": "Finder",
    "partnerEdit.b2bToggle.fiduciary": "Fiduciary",
    "partnerEdit.b2bToggle.intermediaryModel": "Intermediary model",
    "partnerEdit.b2bToggle.eam": "EAM",
    "partnerEdit.b2bToggle.efa": "EFA",
    "partnerEdit.b2bToggle.eamEpaCode": "EAM EPA code",
    "partnerEdit.b2bToggle.efaEpaCode": "EFA EPA code",
    "partnerEdit.b2bToggle.insuranceModel": "Insurance model",
    "partnerEdit.b2bToggle.fiduciarySetup": "Fiduciary setup",
    "home.tab.taskManager.taskManager": "TASK MANAGER",
    "home.tabs.myTasks": "My Tasks",
    "home.tabs.teamTasks": "Team Tasks",
    "home.tabs.allTasks": "All Tasks",
    "home.tabs.findTask": "Find Task",
    "home.tabs.manageTasks": "Manage Tasks",
    "home.tabs.wrokflows": "Workflows",
    "home.tabs.tools": "Tools",
    "home.tabs.adhocScreen": "Ad hoc screening",
    "distributionCenter.agreement.forwarding": "Agreement forwarding",
    "distributionCenter.agreement.tracking": "Agreement tracking",
    "more.reject.title": "Reject (Bank PoV)",
    "more.withdraw.title": "Withdraw (Partner PoV)",
    "more.reActivate.title": "Re-activate prospect",
    "more.gdprRequest.title": "GDPR data request",
    "more.gdprRemoval.title": "GDPR data removal",
    "more.withdraw.button.dlmAccess": "Withdrawn can be done only when there are no Draft changes.",
    "more.reject.button.dlmAccess": "Rejection can be done only when there are no Draft changes.",
    "more.reassign.button.dlmAccess": "Reassignment of RM for Prospects can be done only when there are no Draft changes.",
    "more.withdrawn.tooltip.status": "Only partners with the status 'Prospecting' can be withdrawn from this section.",
    "more.reject.tooltip.status": "Only partners with the status 'Prospecting' can be rejected from this section.",
    "more.reassign.tooltip.status": "Only partners with the status 'Prospecting' or 'Onboarding' can be reassigned.",
    "more.reactivateStatus.tooltip": "Only partners with the status 'Rejected' or 'Withdrawn' can be re-enabled.",
    "more.reactivate.prospect.tooltip.message": "Only assigned relationship managers or relationship manager assistants or team heads can re-activate prospects.",
    "more.withdraw.partners.tooltip.message": "Only assigned relationship managers or relationship manager assistants or team heads can withdraw partners.",
    "more.reject.partners.tooltip.message": "Only assigned relationship managers or relationship manager assistants or team heads can reject partners.",
    "revisionHistory.title": "Change history",
    "revisionHistory.title.br": "Change history",
    "revisionHistory.dateRange": "Date range",
    "revisionHistory.search.label": "Search",
    "revisionHistory.search.placeholder": "Search by modified by",
    "revisionHistory.commentSwitch": "Show all change comments",
    "revisionHistory.table.editedOn": "Edited on",
    "revisionHistory.table.editedBy": "Edited by",
    "revisionHistory.table.submittedBy": "Submitted by",
    "revisionHistory.table.unsubmittedChanges": "Unsubmitted changes",
    "revisionHistory.table.unsubmittedChangesInfo": "The following changes have not been submitted yet. To submit the changes, go to the Profile - Core Data tab and click on \"Submit changes\" in the save bar",
    "revisionHistory.table.status": "Status",
    "revisionHistory.table.section": "Section",
    "revisionHistory.table.attribute": "Attribute",
    "revisionHistory.table.previousValue": "Previous value",
    "revisionHistory.table.newValue": "New value",
    "revisionHistory.table.changeComment": "Change comment",
    "revisionHistory.table.viewDetails": "View details",
    "revisionHistory.table.close": "Close",
    "revisionHistory.table.error.tooltip": "Error loading editing history for this section. Click to view error details.",
    "revisionHistory.table.error.title": "Error retrieving comparison details",
    "revisionHistory.table.error.message": "Error loading editing history for section \"{{sectionName}}\"",
    "more.view.crm.title": "View in CRM",
    "more.rm-reassign.title": "Reassign RM",
    "more.rm-reassign.currentRm": "Current relationship manager",
    "more.rm-reassign.newRm": "New relationship manager",
    "more.error.reason": "Please select reason",
    "more.error.otherReason": "Other reason is required",
    "topbar.gphd.title": "GPHD",
    "feedback.error.required": "Please provide a rating.",
    "feedback.title.disclaimer": "This is NOT a tool to raise incidents, do not enter any CID.",
    "feedback.question.feedback": "What else would you like to tell us?",
    "feedback.question.userFriendly": "The new CLM application is user friendly.",
    "feedback.question.timeSaving": "With CLM, I save time in managing data compared to CRM.",
    "feedback.question.satisfaction": "I am satisfied with the new CLM application.",
    "feedback.question.release": "I feel well taken care of after CLM releases.",
    "modals.successDialog.title": "Confirmation",
    "modals.rejectWithdraw.successMessage": "Prospect {{actionType}} successful",
    "common.button.ok": "Ok",
    "modals.errorDialog.rejectionWithdrawalError": "Prospect {{actionType }} not successful. Please retry after some time.",
    "accessDenied.title": "Access denied",
    "accessDenied.br.subtitle": "You do not have permission to view this business relationship.",
    "multipleTabs.warning": "Warning: You have multiple tabs open for this {{type}}. Please use only one tab to avoid conflicts and data loss when editing.",
    "multipleTabs.warning.businessRelation": "business relationship",
    "multipleTabs.warning.partner": "partner",
    "dlm.switch.tooltip.ACTIVE": "<strong>Viewing (Read-only)</strong><br/>You are viewing the last submitted data.<br/>To make changes, switch to Editing Mode.",
    "dlm.switch.tooltip.DRAFT": "<strong>Editing Draft (Changes not submitted)</strong><br>You are editing a draft. Saved changes will remain in draft mode until you submit them.",
    "br-label-icon": "BR",
    "partner-label-icon": "PARTNER",
    "navigationWizard.title": "BR profiling",
    "navigationWizard.instructions.error": "Failed to load instructions",
    "navigationWizard.instructions.empty": "No instructions available for this section",
    "navigationWizard.section.title.general": "General",
    "navigationWizard.section.title.profile": "Profile",
    "navigationWizard.section.title.relationships": "Relationships",
    "navigationWizard.section.title.products": "Products",
    "navigationWizard.section.title.portfolioCashAccounts": "Portfolio & cash accounts",
    "navigationWizard.section.title.contactNotes": "Contact notes",
    "navigationWizard.section.title.documents": "Documents",
    "navigationWizard.section.title.reporting": "Reporting",
    "navigationWizard.item.title.brCoreData": "Core data",
    "navigationWizard.item.title.brPurpose": "BR profile",
    "navigationWizard.item.title.deliveryInstructions": "Delivery instructions",
    "navigationWizard.item.title.riskConsiderations": "Risk considerations",
    "navigationWizard.item.title.investmentProfile": "Investment profile",
    "navigationWizard.item.title.clientReview": "Client Reviews",
    "navigationWizard.item.title.blockingInstructions": "Blocking instructions & restrictions",
    "navigationWizard.item.title.waivers": "Waivers",
    "navigationWizard.item.title.countryRiskWaivers": "Country risk waivers",
    "navigationWizard.item.title.brRelations": "Partner relations",
    "navigationWizard.item.title.servicingUsers": "Servicing users",
    "navigationWizard.item.title.financials": "Financials",
    "navigationWizard.item.title.brContactNotes": "Contact notes",
    "navigationWizard.item.title.documents.distribution": "Distribution",
    "navigationWizard.item.title.documents.overview": "Overview",
    "navigationWizard.item.title.documents.collection": "Collection",
    "navigationWizard.item.title.documents.reporting": "KYC reports",
    "clientReadiness.modal.title": "Client setup readiness check",
    "br.overview.title": "Client setup",
    "br.overview.description": "Overview",
    "br.relationship.title": "BR",
    "notification.mark-read-label": "Mark read",
    "notification.mark-unread-label": "Mark unread",
    "notification.settingsModal.title": "Notification Settings",
    "notification.settingsModal.channelLabel": "Notification channel",
    "notification.settingsModal.channelClmLabel": "In CLM",
    "notification.settingsModal.channelEmailLabel": "Email",
    "notification.settingsModal.forwardLabel": "Forward",
    "notification.settingsModal.userDropdownLabel": "Name or user ID",
    "notification.settingsModal.userDropdownPlaceholderLabel": "Search by username or ID",
    "notification.settingsModal.userDropdownNotFoundLabel": "No results found",
    "notification.settingsModal.dateRangeLabel": "Date range",
    "notification.settingsModal.saveButtonLabel": "Save settings",
    "notification.settingsModal.cancelButtonLabel": "Cancel"
  }
}
